import React from "react";
import getOrderStatusDataForTrack, {
  allStatus
} from "../../../../../lib/getOrderStatusForTrack";

const ButtonSection = ({
  order,
  handleRateOrder,
  handleReOrder,
  handleTipOrder,
  orderUid,
  deliveryDriver,
  restaurantDeliveryType
}) => {
  const canTrack = () => {
    const currentStatusId = getOrderStatusDataForTrack(order.status);
    const currentStatus = allStatus.find(
      status => status.id === currentStatusId
    );

    return (
      currentStatus &&
      order.status !== "ORDER_COMPLETED" &&
      restaurantDeliveryType === "THIRD_PARTY_DELIVERY"
    );
  };
  return (
    <>
      {(order.userCanReOrder && (
        <div className="mt-1 btn-continue">
          <button
            onClick={() => handleReOrder(orderUid)}
            className="btn btn-blue"
          >
            Reorder
          </button>
        </div>
      )) || <noscript />}
      {(order.userCanTip && (
        <div className="mt-1 btn-continue">
          <button
            onClick={() => handleTipOrder(orderUid, deliveryDriver)}
            className="btn btn-blue"
          >
            Tip
          </button>
        </div>
      )) || <noscript />}
      {(order.userCanRate && (
        <div
          className="mt-1 btn-continue"
          onClick={() => handleRateOrder(orderUid)}
        >
          <button className="btn btn-blue">Rate</button>
        </div>
      )) || <noscript />}
      {(canTrack() && (
        <div className="mt-1 btn-continue visible-xs">
          <a className="btn btn-blue" href={`/track-order/${orderUid}`}>
            Track Order
          </a>
        </div>
      )) || <noscript />}
    </>
  );
};

export default ButtonSection;
